package com.yendo.mx.ui

import androidx.compose.animation.*
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.DirectionsBike
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import kotlinx.coroutines.flow.catch
import androidx.compose.material3.pulltorefresh.PullToRefreshBox
import androidx.compose.material3.pulltorefresh.rememberPullToRefreshState
import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.saveable.rememberSaveableStateHolder
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.lifecycle.viewmodel.compose.viewModel
import androidx.lifecycle.createSavedStateHandle
import coil3.compose.AsyncImage
import coil3.compose.LocalPlatformContext
import coil3.request.ImageRequest
import coil3.request.crossfade
import com.yendo.mx.models.RestauranteFirebase
import com.yendo.mx.models.PedidoFirebase
import com.yendo.mx.models.PedidosManager
import com.yendo.mx.models.DireccionGuardada
import com.yendo.mx.models.SeccionHome
import com.yendo.mx.models.BannerYendo
import com.yendo.mx.models.FiltroHome
import com.yendo.mx.models.Producto
import com.yendo.mx.models.UbicacionPedido
import com.yendo.mx.repository.AuthRepository
import com.yendo.mx.repository.HomeRepository
import com.yendo.mx.repository.DireccionesRepository
import com.yendo.mx.ui.components.*
import com.yendo.mx.ui.home.*
import com.yendo.mx.ui.restaurant.DetalleRestaurante
import com.yendo.mx.ui.theme.*
import com.yendo.mx.ui.cart.CarritoScreen
import com.yendo.mx.ui.profile.PerfilScreen
import com.yendo.mx.ui.orders.PedidoActivoScreen
import com.yendo.mx.utils.ConfigManager
import com.yendo.mx.utils.EstadoCarga
import com.yendo.mx.utils.verificarPermisoNotificaciones
import com.yendo.mx.utils.abrirConfiguracionApp
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import dev.gitlive.firebase.firestore.where
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import com.yendo.mx.utils.getAhora
import kotlinx.datetime.Instant
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlinx.datetime.DayOfWeek
import com.yendo.mx.utils.BackHandler
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.input.nestedscroll.NestedScrollConnection
import androidx.compose.ui.input.nestedscroll.NestedScrollSource
import androidx.compose.ui.input.nestedscroll.nestedScroll
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.unit.IntOffset
import kotlin.math.roundToInt
import com.yendo.mx.models.CartManager

// 🚀 IMPORTS DE RECURSOS Y COMPOTTIE
import org.jetbrains.compose.resources.ExperimentalResourceApi
import yendo.shared.generated.resources.*
import io.github.alexzhirkevich.compottie.Compottie
import io.github.alexzhirkevich.compottie.LottieCompositionSpec
import io.github.alexzhirkevich.compottie.rememberLottieComposition
import io.github.alexzhirkevich.compottie.rememberLottiePainter

@OptIn(ExperimentalMaterial3Api::class, ExperimentalResourceApi::class)
@Composable
fun HomeScreen(
    esInvitado: Boolean = false,
    homeViewModel: HomeViewModel = viewModel { HomeViewModel() },
    idPedidoDeepLink: String? = null, // 🚀 RECIBIMOS EL DEEP LINK
    onCerrarSesion: () -> Unit
) {
    val usuario by AuthRepository.usuarioActual.collectAsState()
    val coroutineScope = rememberCoroutineScope()
    val snackbarHostState = remember { SnackbarHostState() }

    var showSoftUpdateDialog by rememberSaveable { mutableStateOf(com.yendo.mx.repository.ConfigGlobalRepository.mostrarSoftUpdateEnHome) }
    val urlUpdateOpcional = com.yendo.mx.repository.ConfigGlobalRepository.urlSoftUpdate

    // 🚀 INYECTAMOS EL SOLICITADOR DE GPS SILENCIOSO
    InyectarGpsSilencioso()

    // 🚀 INTERCEPTOR 1: CUARENTENA ABSOLUTA (EARLY RETURN)
    val usuarioActual = usuario
    if (usuarioActual?.bloqueado == true) {
        com.yendo.mx.ui.profile.CuentaBloqueadaScreen(
            usuario = usuarioActual,
            onCerrarSesion = {
                coroutineScope.launch { AuthRepository.cerrarSesion() }
                onCerrarSesion()
            }
        )
        return // 🚀 No procesa ni dibuja NADA de lo que hay abajo
    }

    // 🚀 INTERCEPTOR 2: RECUPERACIÓN SOFT-DELETE (EARLY RETURN)
    if (usuario?.eliminacion_pendiente == true) {
        com.yendo.mx.ui.profile.CuentaEnRecuperacionScreen(
            onRestaurar = {
                coroutineScope.launch { AuthRepository.restaurarCuenta() }
            },
            onCerrarSesion = {
                coroutineScope.launch { AuthRepository.cerrarSesion() }
                onCerrarSesion()
            }
        )
        return // 🚀 No procesa ni dibuja NADA de lo que hay abajo
    }

    val isDark = isSystemInDarkTheme()
    val colorFondoGlobal = if (isDark) Color(0xFF121212) else Color(0xFFF8F8F8)
    val colorFondoTarjetas = if (isDark) Color(0xFF1E1E1E) else Color.White
    val colorFondoTarjetasSecundario = if (isDark) Color(0xFF2C2C2E) else Color(0xFFF9F9F9)
    val colorTextoPrincipal = if (isDark) Color.White else Color.Black
    val colorTextoSecundario = if (isDark) Color(0xFFAAAAAA) else Color.Gray

    var destinoActual by rememberSaveable { mutableStateOf("HOME") }
    var procesandoAccion by remember { mutableStateOf(false) } // 🚀 Estado global de carga para clics asíncronos

    var mostrarPromoFlash by remember { mutableStateOf(false) }
    var promoYaMostradaEnSesion by remember { mutableStateOf(false) }
    var configPromoZona by remember { mutableStateOf<com.yendo.mx.models.ConfiguracionZona?>(null) }
    
    var mostrarDialogoPermisoNotificaciones by remember { mutableStateOf(false) }
    var permisoChecadoEnSesion by rememberSaveable { mutableStateOf(false) }
    val abrirConfig = abrirConfiguracionApp()
    
    var correoVerificacionEnviado by rememberSaveable { mutableStateOf(false) }
    
    val uriHandler = LocalUriHandler.current

    // 🚀 OPTIMIZACIÓN: Carga en memoria el JSON una sola vez
    val lottieCargando by rememberLottieComposition {
        LottieCompositionSpec.JsonString(Res.readBytes("files/yendo_cargando.json").decodeToString())
    }

    val restauranteSeleccionado = remember { mutableStateOf<RestauranteFirebase?>(null) }
    val productoAExplorar = remember { mutableStateOf<Producto?>(null) }
    val seccionAExplorar = remember { mutableStateOf<SeccionHome?>(null) }

    val mostrarCarrito = remember { mutableStateOf(false) }
    val mostrarPerfil = remember { mutableStateOf(false) }
    val mostrarFavoritos = remember { mutableStateOf(false) } 
    val mostrarNotificaciones = remember { mutableStateOf(false) }
    val mostrarPantallaPedidoActivo = remember { mutableStateOf(false) }
    val mostrarDialogoInvitado = remember { mutableStateOf(false) }
    val mostrarDialogoBienvenida = remember { mutableStateOf(false) }
    var mostrarSheetMultiplesPedidos by remember { mutableStateOf(false) }

    val idPedidoEnTransito = remember { mutableStateOf("") }
    val pedidosActivos = remember { mutableStateListOf<PedidoFirebase>() }

    val mostrarMapa = remember { mutableStateOf(false) }
    var forzarGpsAlAbrirMapa by remember { mutableStateOf(false) }
    var indiceEdicion by remember { mutableStateOf(-1) }
    var direccionPrevia by remember { mutableStateOf("") }
    var direccionAEditar by remember { mutableStateOf<DireccionGuardada?>(null) }

    val direccionActiva = remember { mutableStateOf<DireccionGuardada?>(null) }
    var latitudEntrega by remember { mutableStateOf(0.0) }
    var longitudEntrega by remember { mutableStateOf(0.0) }

    val metodosBloqueadosUsuario = usuario?.metodos_pago_bloqueados ?: ""
    val estadoZona by ConfigManager.estadoConfig.collectAsState()
    val mostrarSheetUbicacion = remember { mutableStateOf(false) }

    val enviosVM: EnviosViewModel = viewModel { EnviosViewModel(createSavedStateHandle()) }
    var contextoMapaEnvio by remember { mutableStateOf<Boolean?>(null) }

    // 🚀 ESTADOS DE SCROLL ELEVADOS Y PERSISTENTES AL RETORNAR DE DETALLE O PESTAÑAS
    val listStateComida = rememberSaveable(saver = LazyListState.Saver) { LazyListState() }
    val listStateComercios = rememberSaveable(saver = LazyListState.Saver) { LazyListState() }

    var hayNotificacionesNoLeidas by remember { mutableStateOf(false) }

    var mostrarExitoStaff by remember { mutableStateOf(false) }
    var nombreNegocioStaff by remember { mutableStateOf("") }

    // 🚀 LÓGICA DE OCULTAR BOTTOM NAV AL HACER SCROLL (EFECTO UBER/RAPPI)
    val bottomBarHeight = 96.dp
    val bottomBarHeightPx = with(LocalDensity.current) { bottomBarHeight.toPx() }
    val bottomBarOffsetHeightPx = remember { mutableStateOf(0f) }

    val nestedScrollConnection = remember {
        object : NestedScrollConnection {
            override fun onPreScroll(available: Offset, source: NestedScrollSource): Offset {
                val delta = available.y
                val newOffset = bottomBarOffsetHeightPx.value + delta
                bottomBarOffsetHeightPx.value = newOffset.coerceIn(-bottomBarHeightPx, 0f)
                return Offset.Zero
            }
        }
    }

    LaunchedEffect(usuario?.uid) {
        val uid = usuario?.uid
        if (uid != null && uid.isNotEmpty()) {
            try {
                Firebase.firestore.collection("Usuarios").document(uid)
                    .collection("Notificaciones")
                    .where { "leida" equalTo false } // 🚀 FILTRO PROFESIONAL: Solo buscamos las no leídas
                    .limit(1) // 🚀 AHORRO DE COSTOS: Solo nos interesa saber si existe al menos una
                    .snapshots
                    .catch { println("YENDO_LOG: Error en sensor de notificaciones - ${it.message}") }
                    .collect { snapshot ->
                        hayNotificacionesNoLeidas = snapshot.documents.isNotEmpty()
                    }
            } catch (e: Exception) {
                println("YENDO_ERROR: Falló sensor de notificaciones - ${e.message}")
            }
        }
    }

    com.yendo.mx.utils.SolicitarPermisoNotificaciones()

    // 🚀 INTERCEPTOR DE DEEP LINKS
    LaunchedEffect(idPedidoDeepLink) {
        if (idPedidoDeepLink != null && idPedidoDeepLink.isNotEmpty()) {
            idPedidoEnTransito.value = idPedidoDeepLink
            mostrarPantallaPedidoActivo.value = true
        }
    }

    LaunchedEffect(Unit) {
        com.yendo.mx.utils.obtenerTokenFirebase { token ->
            coroutineScope.launch {
                AuthRepository.actualizarTokenPush(token)
            }
        }
    }

    val saveableStateHolder = rememberSaveableStateHolder()
    val direccionesState = DireccionesRepository.observarMisDirecciones().collectAsState(initial = null)
    // 🚀 OPTIMIZACIÓN: Solo ordena la lista si los datos de la base de datos cambian
    val listaDirecciones = remember(direccionesState.value) {
        direccionesState.value?.sortedByDescending { it.ultimaVezUsada } ?: emptyList()
    }
    var inicializado by remember { mutableStateOf(false) }

    // 🚀 DETECTOR PROFESIONAL DE PERMISOS (Solo para usuarios reales, una vez por sesión)
    if (!esInvitado && !permisoChecadoEnSesion) {
        verificarPermisoNotificaciones { concedido ->
            if (!concedido) {
                mostrarDialogoPermisoNotificaciones = true
            }
            permisoChecadoEnSesion = true
        }
    }

    // 🚀 REFRESH DE ESTADO DE VERIFICACIÓN (Al entrar al Home)
    LaunchedEffect(Unit) {
        if (!esInvitado) {
            AuthRepository.recargarUsuario()
        }
    }

    BackHandler(enabled = restauranteSeleccionado.value != null) {
        restauranteSeleccionado.value = null
        productoAExplorar.value = null
    }

    BackHandler(enabled = (destinoActual != "HOME" || mostrarFavoritos.value) && restauranteSeleccionado.value == null) {
        if (mostrarFavoritos.value) mostrarFavoritos.value = false
        else destinoActual = "HOME"
    }

    LaunchedEffect(estadoZona, direccionActiva.value) {
        if (estadoZona is EstadoCarga.Exito && direccionActiva.value != null) {
            val zonaActual = (estadoZona as EstadoCarga.Exito).config
            configPromoZona = zonaActual

            if (zonaActual.promo_flash?.activa == true && !promoYaMostradaEnSesion && !esInvitado) {
                delay(1500) // 🚀 Esperamos a que el Home esté visible y estable
                mostrarPromoFlash = true
                promoYaMostradaEnSesion = true
            }
        }
    }

    LaunchedEffect(direccionesState.value) {
        if (!inicializado && direccionesState.value != null) {
            if (listaDirecciones.isNotEmpty()) {
                val dirPorDefecto = listaDirecciones.first()
                direccionActiva.value = dirPorDefecto
                latitudEntrega = dirPorDefecto.lat
                longitudEntrega = dirPorDefecto.lng
                ConfigManager.procesarUbicacion(dirPorDefecto.lat, dirPorDefecto.lng, dirPorDefecto.cp)
            } else {
                direccionActiva.value = null
                mostrarDialogoBienvenida.value = true
            }
            inicializado = true
        }
    }

    LaunchedEffect(esInvitado) {
        if (!esInvitado) {
            PedidosManager.observarTodosLosPedidosActivos().collect { lista ->
                pedidosActivos.clear()
                pedidosActivos.addAll(lista)
                val pedidoParaCalificar = lista.firstOrNull { it.estadoActual == "ENTREGADO" }
                if (pedidoParaCalificar != null) {
                    idPedidoEnTransito.value = pedidoParaCalificar.idPedido
                    mostrarPantallaPedidoActivo.value = true
                }
            }
        }
    }

    Box(modifier = Modifier.fillMaxSize()) {
        when {
            mostrarMapa.value -> {
                MapaSeleccionScreen(
                    direccionInicial = direccionPrevia,
                    direccionAEditar = direccionAEditar, 
                    buscarGpsAlAbrir = forzarGpsAlAbrirMapa, 
                    modoSoloSeleccion = contextoMapaEnvio != null,
                    puedeCerrar = listaDirecciones.isNotEmpty(), // 🚀 SI NO HAY DIRECCIONES, ES MANDATORIO
                    onBack = { 
                        if (listaDirecciones.isNotEmpty()) {
                            mostrarMapa.value = false
                            forzarGpsAlAbrirMapa = false
                            indiceEdicion = -1
                            direccionAEditar = null 
                            direccionActiva.value?.let { dir ->
                                coroutineScope.launch { ConfigManager.procesarUbicacion(dir.lat, dir.lng, dir.cp) }
                            }
                        } else {
                            // 🚀 SI ES NUEVO O INVITADO (Sin direcciones), NO DEJAMOS SALIR SIN UBICACIÓN
                            coroutineScope.launch {
                                snackbarHostState.showSnackbar("Selecciona una ubicación para ver los negocios en tu zona")
                            }
                        }
                    },
                    onConfirmar = { etiqueta, direccionFinal, lat, lng, cp, tipo, opcion, notas ->
                        if (contextoMapaEnvio != null) {
                            val ubi = UbicacionPedido(
                                direccion = direccionFinal, latitude = lat, longitude = lng,
                                tipoUbicacion = tipo, opcionEntrega = opcion, indicaciones = notas
                            )
                            if (contextoMapaEnvio == true) enviosVM.origen = ubi else enviosVM.destino = ubi
                            enviosVM.calcularCotizacion()
                            contextoMapaEnvio = null
                        } else {
                            val idExistente = listaDirecciones.getOrNull(indiceEdicion)?.id ?: ""
                            val nuevaDireccion = DireccionGuardada(
                                id = idExistente, titulo = etiqueta, direccion = direccionFinal, lat = lat, lng = lng, cp = cp,
                                tipoUbicacion = tipo, opcionEntrega = opcion, indicaciones = notas,
                                ultimaVezUsada = getAhora()
                            )
                            coroutineScope.launch {
                                DireccionesRepository.guardarDireccion(nuevaDireccion)
                                ConfigManager.procesarUbicacion(lat, lng, cp)
                            }
                            direccionActiva.value = nuevaDireccion
                            latitudEntrega = lat
                            longitudEntrega = lng
                        }
                        direccionAEditar = null 
                        mostrarMapa.value = false
                        indiceEdicion = -1
                        forzarGpsAlAbrirMapa = false
                    }
                )
            }

            mostrarPantallaPedidoActivo.value -> {
                PedidoActivoScreen(
                    idPedido = idPedidoEnTransito.value,
                    onBack = { mostrarPantallaPedidoActivo.value = false; idPedidoEnTransito.value = "" }
                )
            }

            mostrarFavoritos.value -> {
                if (esInvitado) {
                    LaunchedEffect(Unit) { mostrarFavoritos.value = false; mostrarDialogoInvitado.value = true }
                } else {
                    com.yendo.mx.ui.profile.MisFavoritosScreen(
                        onBack = { mostrarFavoritos.value = false },
                        onRestauranteClick = { rest ->
                            mostrarFavoritos.value = false
                            restauranteSeleccionado.value = rest
                        },
                        onProductoClick = { prod, rest ->
                            mostrarFavoritos.value = false
                            productoAExplorar.value = prod
                            restauranteSeleccionado.value = rest
                        }
                    )
                }
            }

            mostrarPerfil.value -> {
                if (esInvitado) {
                    LaunchedEffect(Unit) { mostrarPerfil.value = false; mostrarDialogoInvitado.value = true }
                } else {
                    PerfilScreen(
                        onBack = { mostrarPerfil.value = false }, 
                        onCerrarSesion = onCerrarSesion,
                        onRestauranteClick = { rest -> restauranteSeleccionado.value = rest },
                        onProductoClick = { prod, rest ->
                            productoAExplorar.value = prod
                            restauranteSeleccionado.value = rest
                        }
                    )
                }
            }

            mostrarNotificaciones.value -> {
                if (esInvitado) {
                    LaunchedEffect(Unit) { mostrarNotificaciones.value = false; mostrarDialogoInvitado.value = true }
                } else {
                    com.yendo.mx.ui.profile.NotificacionesScreen(
                        onBack = { mostrarNotificaciones.value = false },
                        onAbrirPedido = { idPedido ->
                            idPedidoEnTransito.value = idPedido
                            mostrarNotificaciones.value = false
                            mostrarPantallaPedidoActivo.value = true
                        },
                        onAbrirNegocio = { id ->
                            coroutineScope.launch {
                                procesandoAccion = true
                                try {
                                    val doc = Firebase.firestore.collection("Negocios").document(id).get()
                                    val rest = doc.data<RestauranteFirebase>().copy(id = doc.id)

                                    if (rest.operacion.visible && rest.operacion.activoComercio) {
                                        restauranteSeleccionado.value = rest
                                        mostrarNotificaciones.value = false
                                    } else {
                                        println("⚠️ Negocio no visible actualmente.")
                                    }
                                } catch (e: Exception) {
                                    println("Error: $e")
                                } finally {
                                    procesandoAccion = false
                                }
                            }
                        }
                    )
                }
            }

            mostrarCarrito.value -> {
                if (esInvitado) {
                    LaunchedEffect(Unit) { 
                        mostrarCarrito.value = false
                        mostrarDialogoInvitado.value = true 
                    }
                } else {
                    CarritoScreen(
                        onBack = { mostrarCarrito.value = false },
                        esInvitado = false,
                        onSugerirRegistro = { }, // Ya no es necesario si bloqueamos arriba
                        direccionActual = direccionActiva.value?.direccion ?: "Ubicación no seleccionada",
                        latitudCliente = latitudEntrega,
                        longitudCliente = longitudEntrega,
                        metodosBloqueadosCliente = metodosBloqueadosUsuario,
                        onPedidoConfirmado = { idGenerado: String ->
                            idPedidoEnTransito.value = idGenerado
                            mostrarCarrito.value = false
                            mostrarPantallaPedidoActivo.value = true
                        }
                    )
                }
            }

            restauranteSeleccionado.value != null -> {
                DetalleRestaurante(
                    restaurante = restauranteSeleccionado.value!!,
                    productoInicial = productoAExplorar.value,
                    onBack = {
                        restauranteSeleccionado.value = null
                        productoAExplorar.value = null
                    },
                    onVerCarrito = { _ -> mostrarCarrito.value = true }
                )
            }

            seccionAExplorar.value != null -> {
                ExplorarSeccionScreen(
                    seccion = seccionAExplorar.value!!,
                    idZonaActual = (estadoZona as? EstadoCarga.Exito)?.id_zona ?: "",
                    colorTextoPrincipal = colorTextoPrincipal,
                    colorFondoTarjetas = colorFondoTarjetas,
                    onBack = { seccionAExplorar.value = null },
                    onRestauranteClick = { rest -> restauranteSeleccionado.value = rest },
                    onProductoClick = { producto, rest -> 
                        val estaAbierto = rest.operacion.estado == "ACTIVO" && !rest.operacion.bloqueadoPorAdmin && !rest.operacion.pausadoManualmente
                        val permiteProgramar = rest.operacion.programadoActivo

                        if (estaAbierto || permiteProgramar) {
                            productoAExplorar.value = producto
                            restauranteSeleccionado.value = rest
                        } else {
                            productoAExplorar.value = null
                            restauranteSeleccionado.value = rest
                        }
                    },
                    procesandoAccion = { procesandoAccion = it } 
                )
            }

            else -> {
                Scaffold(
                    modifier = Modifier.nestedScroll(nestedScrollConnection), 
                    containerColor = colorFondoGlobal,
                    snackbarHost = { SnackbarHost(snackbarHostState) }
                ) { padding ->
                    val pullRefreshState = rememberPullToRefreshState()
                    var isRefreshing by remember { mutableStateOf(false) }

                    PullToRefreshBox(
                        isRefreshing = isRefreshing,
                        onRefresh = { 
                            coroutineScope.launch { 
                                isRefreshing = true
                                // 🚀 FORZAMOS RECARGA DE CONFIGURACIÓN Y NEGOCIOS
                                ConfigManager.recargarConfiguracionActual()
                                delay(800) // Margen visual
                                isRefreshing = false 
                            } 
                        },
                        state = pullRefreshState,
                        modifier = Modifier.padding(padding).fillMaxSize()
                    ) {
                        Box(modifier = Modifier.fillMaxSize()) {
                            Column(modifier = Modifier.fillMaxSize()) {
                                val alertaActual = ConfigManager.configActiva?.alerta_operativa
                                BannerAlertaOperativa(alertaActual)

                                    val proveedor = AuthRepository.obtenerProveedorAuth()
                                    val u = usuario
                                    if (u != null && !u.emailVerificado && !u.esInvitado && (proveedor == "Correo" || proveedor == "Telefono")) {
                                        Surface(
                                            modifier = Modifier.fillMaxWidth(),
                                            color = Color(0xFF331111)
                                        ) {
                                            Column(modifier = Modifier.padding(16.dp)) {
                                                Row(verticalAlignment = Alignment.CenterVertically) {
                                                    Icon(Icons.Default.Unsubscribe, null, tint = Color.Red, modifier = Modifier.size(24.dp))
                                                    Spacer(Modifier.width(12.dp))
                                                    Text(
                                                        "Verifica tu correo electrónico",
                                                        color = Color.White,
                                                        fontSize = 15.sp,
                                                        fontWeight = FontWeight.ExtraBold
                                                    )
                                                }

                                                Spacer(Modifier.height(8.dp))

                                                Text(
                                                    if (correoVerificacionEnviado) "Revisa tu bandeja de entrada y haz clic en el enlace de seguridad." else "Es necesario validar tu identidad. Haz clic para recibir tu enlace.",
                                                    color = Color.White.copy(alpha = 0.8f),
                                                    fontSize = 13.sp,
                                                    lineHeight = 18.sp
                                                )

                                                Spacer(Modifier.height(16.dp))

                                                Row(
                                                    modifier = Modifier.fillMaxWidth(),
                                                    horizontalArrangement = Arrangement.End,
                                                    verticalAlignment = Alignment.CenterVertically
                                                ) {
                                                    if (!correoVerificacionEnviado) {
                                                        Button(
                                                            onClick = {
                                                                coroutineScope.launch {
                                                                    val res = AuthRepository.enviarCorreoVerificacion(usuario?.email)
                                                                    if (res == "OK") {
                                                                        correoVerificacionEnviado = true
                                                                        snackbarHostState.showSnackbar("Correo enviado. Revisa tu bandeja de entrada.")
                                                                    } else {
                                                                        snackbarHostState.showSnackbar("Error: $res")
                                                                    }
                                                                }
                                                            },
                                                            colors = ButtonDefaults.buttonColors(containerColor = RosaYendo),
                                                            shape = RoundedCornerShape(8.dp),
                                                            contentPadding = PaddingValues(horizontal = 16.dp, vertical = 8.dp)
                                                        ) {
                                                            Text("Enviar enlace", fontWeight = FontWeight.Bold, fontSize = 13.sp, color = Color.White)
                                                        }
                                                    } else {
                                                        TextButton(
                                                            onClick = {
                                                                coroutineScope.launch {
                                                                    AuthRepository.recargarUsuario()
                                                                    if (usuario?.emailVerificado == true) {
                                                                        snackbarHostState.showSnackbar("¡Cuenta verificada con éxito!")
                                                                    } else {
                                                                        snackbarHostState.showSnackbar("Aún no detectamos la verificación.")
                                                                    }
                                                                }
                                                            },
                                                            colors = ButtonDefaults.textButtonColors(contentColor = Color.White)
                                                        ) {
                                                            Text("Ya lo hice", fontWeight = FontWeight.Bold, fontSize = 13.sp)
                                                        }

                                                        Spacer(Modifier.width(8.dp))

                                                        Button(
                                                            onClick = {
                                                                coroutineScope.launch {
                                                                    val res = AuthRepository.enviarCorreoVerificacion()
                                                                    if (res == "OK") {
                                                                        snackbarHostState.showSnackbar("Correo reenviado con éxito.")
                                                                    } else {
                                                                        snackbarHostState.showSnackbar("Error: $res")
                                                                    }
                                                                }
                                                            },
                                                            colors = ButtonDefaults.buttonColors(containerColor = RosaYendo),
                                                            shape = RoundedCornerShape(8.dp),
                                                            contentPadding = PaddingValues(horizontal = 16.dp, vertical = 8.dp)
                                                        ) {
                                                            Text("Reenviar", fontWeight = FontWeight.Bold, fontSize = 13.sp, color = Color.White)
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    val textoReapertura = remember(ConfigManager.configActiva) {
                                        ConfigManager.configActiva?.let { config ->
                                            val zonaHoraria = TimeZone.currentSystemDefault()
                                            val ahora = Instant.fromEpochMilliseconds(getAhora()).toLocalDateTime(zonaHoraria)
                                            val minActuales = ahora.hour * 60 + ahora.minute
                                            
                                            val diasSemana = listOf(
                                                DayOfWeek.MONDAY, DayOfWeek.TUESDAY, DayOfWeek.WEDNESDAY,
                                                DayOfWeek.THURSDAY, DayOfWeek.FRIDAY, DayOfWeek.SATURDAY, DayOfWeek.SUNDAY
                                            )
                                            val indiceHoy = diasSemana.indexOf(ahora.dayOfWeek)
                                            
                                            for (i in 0..6) {
                                                val indiceDia = (indiceHoy + i) % 7
                                                val diaSut = diasSemana[indiceDia]
                                                val nombreDiaSut = com.yendo.mx.utils.LogisticaUtils.obtenerNombreDiaEspanol(diaSut)
                                                val hor = config.operacion.horario_semanal[nombreDiaSut]
                                                
                                                if (hor?.activo == true) {
                                                    val aperturaMin = com.yendo.mx.utils.LogisticaUtils.aMinutos(hor.apertura)
                                                    val cierreMin = com.yendo.mx.utils.LogisticaUtils.aMinutos(hor.cierre)
                                                    
                                                    if (i == 0) {
                                                        if (minActuales < aperturaMin) return@let "a las ${hor.apertura}"
                                                        if (minActuales > cierreMin) continue 
                                                    } else {
                                                        val prefijo = if (i == 1) "mañana" else "el ${nombreDiaSut.lowercase()}"
                                                        return@let "$prefijo a las ${hor.apertura}"
                                                    }
                                                }
                                            }
                                            "próximamente"
                                        }
                                    }

                                    if (enviosVM.esPlataformaCerrada && textoReapertura != null) {
                                        Surface(
                                            modifier = Modifier.fillMaxWidth(),
                                            color = if(isDark) Color(0xFF331111) else Color(0xFFFFEBEE)
                                        ) {
                                            Row(
                                                modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 10.dp),
                                                verticalAlignment = Alignment.CenterVertically
                                            ) {
                                                Icon(Icons.Default.Schedule, null, tint = Color.Red, modifier = Modifier.size(18.dp))
                                                Spacer(Modifier.width(12.dp))
                                                Text(
                                                    "Solo pickup o programación. Los envíos se reanudan $textoReapertura.",
                                                    color = if(isDark) Color.White else Color.Red,
                                                    fontSize = 13.sp,
                                                    fontWeight = FontWeight.Bold,
                                                    modifier = Modifier.weight(1f)
                                                )
                                            }
                                        }
                                    }

                                    AnimatedContent(
                                        targetState = destinoActual,
                                        transitionSpec = {
                                            fadeIn(animationSpec = androidx.compose.animation.core.spring(stiffness = androidx.compose.animation.core.Spring.StiffnessLow)) togetherWith fadeOut(animationSpec = androidx.compose.animation.core.spring(stiffness = androidx.compose.animation.core.Spring.StiffnessLow))
                                        },
                                        label = "NavegacionMundos",
                                        modifier = Modifier.weight(1f)
                                    ) { pantalla ->
                                        saveableStateHolder.SaveableStateProvider(pantalla) {
                                            Column(modifier = Modifier.fillMaxSize().background(colorFondoGlobal)) {
                                            when (pantalla) {
                                                "HOME" -> {
                                                    Column {
                                                        // 🚀 INVITACIÓN A EQUIPO (EXCLUSIVA: DIBUJA 1 SOLA TARJETA)
                                                        val tieneInvNegocio = usuario?.invitacionNegocio?.get("estado") == "pendiente"
                                                        val tieneInvStaff = usuario?.invitacionStaff?.estado == "pendiente"

                                                        if (tieneInvNegocio) {
                                                            val inv = usuario!!.invitacionNegocio!!
                                                            StaffInvitationBanner(
                                                                nombreNegocio = inv["nombreNegocio"] ?: "",
                                                                rol = inv["rol"] ?: "STAFF",
                                                                onAceptar = {
                                                                    coroutineScope.launch {
                                                                        nombreNegocioStaff = inv["nombreNegocio"] ?: ""
                                                                        val res = AuthRepository.aceptarInvitacionEquipo()
                                                                        if (res == "OK") mostrarExitoStaff = true
                                                                    }
                                                                },
                                                                onRechazar = {
                                                                    coroutineScope.launch { AuthRepository.rechazarInvitacionEquipo() }
                                                                }
                                                            )
                                                        } else if (tieneInvStaff) {
                                                            val invitacion = usuario!!.invitacionStaff!!
                                                            StaffInvitationBanner(
                                                                nombreNegocio = invitacion.nombreNegocio,
                                                                rol = "STAFF",
                                                                onAceptar = {
                                                                    coroutineScope.launch {
                                                                        nombreNegocioStaff = invitacion.nombreNegocio
                                                                        val res = AuthRepository.aceptarInvitacionDeTrabajo(invitacion)
                                                                        if (res == "OK") mostrarExitoStaff = true
                                                                    }
                                                                },
                                                                onRechazar = {
                                                                    coroutineScope.launch { AuthRepository.rechazarInvitacionDeTrabajo() }
                                                                }
                                                            )
                                                        }

                                                        VistaSuperApp(
                                                            isDark = isDark,
                                                            colorFondoTarjetas = colorFondoTarjetas,
                                                            colorTextoPrincipal = colorTextoPrincipal,
                                                            homeViewModel = homeViewModel,
                                                            estadoZona = estadoZona,
                                                            direccionActiva = direccionActiva.value,
                                                            fotoPerfilUrl = usuario?.fotoPerfil ?: "",
                                                            nombreUsuario = usuario?.nombre ?: "Usuario",
                                                            hayNotificacionesNoLeidas = hayNotificacionesNoLeidas,
                                                            onNavegar = { destinoActual = it },
                                                            onVerTodo = { seccion -> seccionAExplorar.value = seccion },
                                                            onRestauranteClick = { rest -> restauranteSeleccionado.value = rest },
                                                            onProductoDirectoClick = { prod, rest ->
                                                                productoAExplorar.value = prod
                                                                restauranteSeleccionado.value = rest
                                                            },
                                                            onAbrirUbicacion = { mostrarSheetUbicacion.value = true },
                                                            onAbrirPerfil = { mostrarPerfil.value = true },
                                                            onAbrirNotificaciones = { mostrarNotificaciones.value = true },
                                                            procesandoAccion = { procesandoAccion = it }
                                                        )
                                                    }
                                                }
                                                "BUSCADOR" -> {
                                                    com.yendo.mx.ui.search.BuscadorAlgoliaScreen(
                                                        focoAutomatico = true, 
                                                        onNegocioClick = { idNegocio ->
                                                            coroutineScope.launch {
                                                                procesandoAccion = true
                                                                try {
                                                                val doc = dev.gitlive.firebase.Firebase.firestore.collection("Negocios").document(idNegocio).get()
                                                                if (doc.exists) {
                                                                    val rest = doc.data<RestauranteFirebase>().copy(id = doc.id)
                                                                    if (rest.operacion.visible && rest.operacion.activoComercio) {
                                                                        restauranteSeleccionado.value = rest
                                                                        destinoActual = "HOME"
                                                                    } else {
                                                                        println("⚠️ Negocio no visible.")
                                                                    }
                                                                }
                                                                } catch (e: Exception) {
                                                                    println("🚨 Error abriendo negocio: ${e.message}")
                                                                } finally {
                                                                    procesandoAccion = false
                                                                }
                                                            }
                                                        },
                                                        onProductoClick = { idProducto, idRestaurante ->
                                                            coroutineScope.launch {
                                                                procesandoAccion = true
                                                                try {
                                                                    println("YENDO_LOG ALGOLIA CLICK: Producto ID: $idProducto, Rest ID: $idRestaurante")
                                                                    var targetNegocioId = idRestaurante
                                                                    var productoEncontrado: Producto? = null

                                                                    // 1. Cargar el documento del Producto directamente desde /Productos/{idProducto}
                                                                    val prodDoc = try { dev.gitlive.firebase.Firebase.firestore.collection("Productos").document(idProducto).get() } catch (e: Exception) { null }

                                                                    if (prodDoc?.exists == true) {
                                                                        productoEncontrado = prodDoc.data<Producto>().copy(id = prodDoc.id)
                                                                        if (targetNegocioId.isBlank()) {
                                                                            targetNegocioId = productoEncontrado.idNegocio.ifBlank { productoEncontrado.idRestaurante }
                                                                        }
                                                                    }

                                                                    if (targetNegocioId.isNotBlank()) {
                                                                        val restDoc = dev.gitlive.firebase.Firebase.firestore.collection("Negocios").document(targetNegocioId).get()
                                                                        if (restDoc.exists) {
                                                                            val rest = restDoc.data<RestauranteFirebase>().copy(id = restDoc.id)
                                                                            productoAExplorar.value = productoEncontrado
                                                                            restauranteSeleccionado.value = rest
                                                                            destinoActual = "HOME"
                                                                            println("YENDO_LOG ALGOLIA REDIRECT: ✅ Abriendo $targetNegocioId con producto ${productoEncontrado?.nombre}")
                                                                        } else {
                                                                            println("🚨 Negocio $targetNegocioId no existe en Firestore")
                                                                        }
                                                                    } else {
                                                                        println("🚨 ID de Negocio nulo/vacío para producto $idProducto")
                                                                    }
                                                                } catch (e: Exception) {
                                                                    println("🚨 Error al redirigir producto: ${e.message}")
                                                                } finally {
                                                                    procesandoAccion = false
                                                                }
                                                            }
                                                        },
                                                        onBack = { destinoActual = "HOME" }
                                                    )
                                                }
                                                "COMIDA" -> {
                                                    VistaComida(
                                                        listState = listStateComida,
                                                        direccionActiva = direccionActiva.value,
                                                        onAbrirUbicacion = { mostrarSheetUbicacion.value = true },
                                                        onRestauranteClick = { restauranteSeleccionado.value = it },
                                                        onProductoDirectoClick = { prod, rest ->
                                                            productoAExplorar.value = prod
                                                            restauranteSeleccionado.value = rest
                                                        },
                                                        onVerTodoSeccion = { seccion -> seccionAExplorar.value = seccion },
                                                        onAbrirBuscador = { destinoActual = "BUSCADOR" },
                                                        onBack = { destinoActual = "HOME" }
                                                    )
                                                }
                                                "COMERCIOS" -> {
                                                    VistaComercios(
                                                        listState = listStateComercios,
                                                        direccionActiva = direccionActiva.value,
                                                        onAbrirUbicacion = { mostrarSheetUbicacion.value = true },
                                                        onRestauranteClick = { restauranteSeleccionado.value = it },
                                                        onProductoDirectoClick = { prod, rest ->
                                                            productoAExplorar.value = prod
                                                            restauranteSeleccionado.value = rest
                                                        },
                                                        onVerTodoSeccion = { seccion -> seccionAExplorar.value = seccion },
                                                        onAbrirBuscador = { destinoActual = "BUSCADOR" },
                                                        onBack = { destinoActual = "HOME" }
                                                    )
                                                }
                                                "ENVIOS" -> {
                                                    if (esInvitado) {
                                                        LaunchedEffect(Unit) {
                                                            destinoActual = "HOME"
                                                            mostrarDialogoInvitado.value = true
                                                        }
                                                    } else {
                                                        VistaEnvios(
                                                            vm = enviosVM,
                                                            onBack = { destinoActual = "HOME" }, 
                                                            onSeleccionarUbicacion = { isOrigen: Boolean ->
                                                                contextoMapaEnvio = isOrigen
                                                                direccionPrevia = if (isOrigen) enviosVM.origen?.direccion ?: "" else enviosVM.destino?.direccion ?: ""
                                                                mostrarMapa.value = true
                                                            },
                                                            onPedidoConfirmado = { idGenerado ->
                                                                idPedidoEnTransito.value = idGenerado
                                                                destinoActual = "HOME" 
                                                                mostrarPantallaPedidoActivo.value = true
                                                            }
                                                        )
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        val esPantallaPrincipal by remember(destinoActual) {
            derivedStateOf { destinoActual in listOf("HOME", "COMIDA", "COMERCIOS", "TIENDITA") }
        }

        val algunModalAbierto by remember(
            mostrarMapa.value, mostrarPerfil.value, mostrarFavoritos.value, mostrarNotificaciones.value, 
            mostrarPantallaPedidoActivo.value, mostrarCarrito.value, 
            restauranteSeleccionado.value, seccionAExplorar.value
        ) {
            derivedStateOf {
                mostrarMapa.value || mostrarPerfil.value || mostrarFavoritos.value || mostrarNotificaciones.value || 
                mostrarPantallaPedidoActivo.value || mostrarCarrito.value || 
                restauranteSeleccionado.value != null || seccionAExplorar.value != null
            }
        }

        if (esPantallaPrincipal && !algunModalAbierto) {
            Box(
                modifier = Modifier
                    .align(Alignment.BottomCenter)
                    .fillMaxWidth()
                    .offset { IntOffset(x = 0, y = (-bottomBarOffsetHeightPx.value).toInt()) } 
                    .navigationBarsPadding()
            ) {
                Column(horizontalAlignment = Alignment.CenterHorizontally) {
                    AnimatedVisibility(
                        visible = pedidosActivos.isNotEmpty(),
                        enter = slideInVertically(initialOffsetY = { it }) + fadeIn(),
                        exit = slideOutVertically(targetOffsetY = { it }) + fadeOut()
                    ) {
                        CardPedidoActivoOverlay(pedidos = pedidosActivos, onClick = { pedido ->
                            if (pedidosActivos.size > 1) mostrarSheetMultiplesPedidos = true else {
                                idPedidoEnTransito.value = pedido.idPedido; mostrarPantallaPedidoActivo.value = true
                            }
                        })
                    }

                    BottomNavBarKitbase(
                        destinoActual = destinoActual,
                        onDestinoSelected = { destinoActual = it },
                        onAbrirCarrito = { mostrarCarrito.value = true },
                        onAbrirFavoritos = { mostrarFavoritos.value = true },
                        onAbrirPerfil = { mostrarPerfil.value = true }
                    )
                }
            }
        }

        if (mostrarDialogoBienvenida.value) {
            DialogoBienvenidaYendo(
                colorTextoPrincipal = colorTextoPrincipal,
                colorTextoSecundario = colorTextoSecundario,
                colorFondoTarjetas = colorFondoTarjetas,
                onDismiss = { },
                onElegirUbicacion = { mostrarDialogoBienvenida.value = false; mostrarMapa.value = true }
            )
        }

        if (mostrarSheetMultiplesPedidos) {
            SheetMultiplesPedidosYendo(
                pedidosActivos = pedidosActivos,
                colorTextoPrincipal = colorTextoPrincipal,
                colorTextoSecundario = colorTextoSecundario,
                colorFondoTarjetas = colorFondoTarjetas,
                colorFondoTarjetasSecundario = colorFondoTarjetasSecundario,
                onDismiss = { mostrarSheetMultiplesPedidos = false },
                onPedidoSeleccionado = { ped ->
                    mostrarSheetMultiplesPedidos = false
                    idPedidoEnTransito.value = ped.idPedido
                    mostrarPantallaPedidoActivo.value = true
                }
            )
        }

        if (mostrarSheetUbicacion.value) {
            SelectorDireccionSheet(
                listaDirecciones = listaDirecciones,
                onDismiss = { mostrarSheetUbicacion.value = false },
                onDireccionSeleccionada = { dirGuardada ->
                    direccionActiva.value = dirGuardada
                    latitudEntrega = dirGuardada.lat
                    longitudEntrega = dirGuardada.lng
                    val dirActualizada = dirGuardada.copy(ultimaVezUsada = getAhora())
                    coroutineScope.launch {
                        DireccionesRepository.guardarDireccion(dirActualizada)
                        ConfigManager.procesarUbicacion(dirActualizada.lat, dirActualizada.lng, dirActualizada.cp)
                    }
                    mostrarSheetUbicacion.value = false
                },
                onUsarUbicacionActual = {
                    forzarGpsAlAbrirMapa = true
                    mostrarSheetUbicacion.value = false
                    mostrarMapa.value = true
                },
                onAbrirMapa = { indice, dirGuardada ->
                    forzarGpsAlAbrirMapa = false 
                    indiceEdicion = indice
                    direccionPrevia = dirGuardada.direccion
                    direccionAEditar = if (indice != -1) dirGuardada else null 
                    mostrarMapa.value = true
                    mostrarSheetUbicacion.value = false
                },
                onEliminarDireccion = { dirAEliminar ->
                    coroutineScope.launch { DireccionesRepository.eliminarDireccion(dirAEliminar.id) }
                }
            )
        }

        if (mostrarDialogoInvitado.value) {
            DialogoInvitadoYendo(
                colorTextoPrincipal = colorTextoPrincipal,
                colorTextoSecundario = colorTextoSecundario,
                colorFondoTarjetas = colorFondoTarjetas,
                onDismiss = { mostrarDialogoInvitado.value = false },
                onRegistrarse = { mostrarDialogoInvitado.value = false; onCerrarSesion() }
            )
        }

        AnimatedVisibility(
            visible = procesandoAccion,
            enter = fadeIn(),
            exit = fadeOut()
        ) {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color.Black.copy(alpha = 0.6f))
                    .clickable(enabled = false) { },
                contentAlignment = Alignment.Center
            ) {
                val painter = rememberLottiePainter(composition = lottieCargando, iterations = Compottie.IterateForever)
                Image(painter = painter, contentDescription = "Cargando", modifier = Modifier.size(250.dp))
            }
        }

        if (mostrarPromoFlash && configPromoZona?.promo_flash != null) {
            PromoFlashDialog(
                promoConfig = configPromoZona!!.promo_flash!!,
                uriHandler = uriHandler,
                coroutineScope = coroutineScope,
                onDismiss = { mostrarPromoFlash = false },
                procesandoAccion = { procesandoAccion = it },
                onRestauranteClick = { restauranteSeleccionado.value = it },
                onProductoDirectoClick = { prod, rest ->
                    productoAExplorar.value = prod
                    restauranteSeleccionado.value = rest
                }
            )
        }

        if (showSoftUpdateDialog && urlUpdateOpcional.isNotEmpty()) {
            AlertDialog(
                onDismissRequest = { 
                    showSoftUpdateDialog = false
                    com.yendo.mx.repository.ConfigGlobalRepository.mostrarSoftUpdateEnHome = false 
                },
                title = { 
                    Text("Nueva versión disponible", fontWeight = FontWeight.Black, color = colorTextoPrincipal) 
                },
                text = { 
                    Text("Tenemos mejoras listas para ti. ¿Deseas descargar la última actualización?", color = colorTextoSecundario) 
                },
                confirmButton = {
                    Button(
                        onClick = { 
                            uriHandler.openUri(urlUpdateOpcional)
                            showSoftUpdateDialog = false
                            com.yendo.mx.repository.ConfigGlobalRepository.mostrarSoftUpdateEnHome = false
                        },
                        colors = ButtonDefaults.buttonColors(containerColor = RosaYendo),
                        shape = RoundedCornerShape(12.dp)
                    ) {
                        Text("Actualizar Ahora", color = Color.White, fontWeight = FontWeight.Bold)
                    }
                },
                dismissButton = {
                    TextButton(onClick = { 
                        showSoftUpdateDialog = false
                        com.yendo.mx.repository.ConfigGlobalRepository.mostrarSoftUpdateEnHome = false
                    }) {
                        Text("Más tarde", color = RosaYendo, fontWeight = FontWeight.Medium)
                    }
                },
                containerColor = colorFondoTarjetas,
                shape = RoundedCornerShape(20.dp)
            )
        }

        if (mostrarExitoStaff) {
            AlertDialog(
                onDismissRequest = { mostrarExitoStaff = false },
                title = { Text("¡Bienvenido al equipo!", fontWeight = FontWeight.Bold) },
                text = { 
                    Text("Oferta aceptada con éxito. Ahora ya eres parte de $nombreNegocioStaff.\n\nPara comenzar a trabajar, descarga la App de Yendo Comercio e inicia sesión.") 
                },
                confirmButton = {
                    Button(
                        onClick = { mostrarExitoStaff = false },
                        colors = ButtonDefaults.buttonColors(RosaYendo)
                    ) { Text("Entendido", color = Color.White) }
                },
                containerColor = colorFondoTarjetas,
                shape = RoundedCornerShape(16.dp)
            )
        }

        if (mostrarDialogoPermisoNotificaciones) {
            AlertDialog(
                onDismissRequest = { mostrarDialogoPermisoNotificaciones = false },
                icon = { Icon(Icons.Default.NotificationsActive, null, tint = RosaYendo, modifier = Modifier.size(40.dp)) },
                title = {
                    Text("¡No te pierdas de nada!", fontWeight = FontWeight.Black, color = colorTextoPrincipal, textAlign = TextAlign.Center)
                },
                text = {
                    Text("Activa las notificaciones para rastrear tus pedidos en tiempo real y recibir avisos sobre tus envíos.", color = colorTextoSecundario, textAlign = TextAlign.Center, lineHeight = 20.sp)
                },
                confirmButton = {
                    Button(
                        onClick = {
                            mostrarDialogoPermisoNotificaciones = false
                            abrirConfig()
                        },
                        colors = ButtonDefaults.buttonColors(containerColor = RosaYendo),
                        shape = RoundedCornerShape(12.dp),
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        Text("Ir a Configuración", color = Color.White, fontWeight = FontWeight.Bold)
                    }
                },
                dismissButton = {
                    TextButton(onClick = { mostrarDialogoPermisoNotificaciones = false }, modifier = Modifier.fillMaxWidth()) {
                        Text("Quizás más tarde", color = colorTextoSecundario, fontWeight = FontWeight.Medium)
                    }
                },
                containerColor = colorFondoTarjetas,
                shape = RoundedCornerShape(24.dp)
            )
        }
    }
}

@Composable
fun BottomNavBarKitbase(
    destinoActual: String,
    onDestinoSelected: (String) -> Unit,
    onAbrirCarrito: () -> Unit,
    onAbrirFavoritos: () -> Unit,
    onAbrirPerfil: () -> Unit
) {
    val isDark = isSystemInDarkTheme()
    val colorFondoGlass = if (isDark) Color(0xFF1E1E1E).copy(alpha = 0.85f) else Color.White.copy(alpha = 0.75f)
    val colorBordeGlass = if (isDark) Color.White.copy(alpha = 0.2f) else Color.Black.copy(alpha = 0.1f)
    val colorInactivo = if (isDark) Color.White.copy(alpha = 0.5f) else Color.Black.copy(alpha = 0.4f)
    
    val cantCarrito = CartManager.totalArticulosBadge

    Surface(
        modifier = Modifier
            .padding(horizontal = 20.dp, vertical = 12.dp)
            .fillMaxWidth()
            .height(72.dp),
        shape = RoundedCornerShape(36.dp),
        color = colorFondoGlass,
        shadowElevation = 25.dp, 
        border = androidx.compose.foundation.BorderStroke(1.dp, colorBordeGlass)
    ) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(
                    Brush.verticalGradient(
                        colors = listOf(
                            Color.White.copy(alpha = if (isDark) 0.05f else 0.3f),
                            Color.Transparent
                        )
                    )
                )
        ) {
            Row(
                modifier = Modifier.fillMaxSize(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceEvenly
            ) {
            IconButton(onClick = { onDestinoSelected("HOME") }) {
                Icon(
                    Icons.Default.Home, null,
                    tint = if (destinoActual == "HOME") RosaYendo else colorInactivo,
                    modifier = Modifier.size(28.dp)
                )
            }
            
            IconButton(onClick = onAbrirFavoritos) {
                Icon(Icons.Default.Favorite, null, tint = colorInactivo, modifier = Modifier.size(28.dp))
            }

            IconButton(onClick = onAbrirCarrito) {
                BadgedBox(
                    badge = {
                        if (cantCarrito > 0) {
                            Badge(
                                containerColor = RosaYendo,
                                contentColor = Color.White
                            ) {
                                Text(cantCarrito.toString())
                            }
                        }
                    }
                ) {
                    Icon(
                        Icons.Default.ShoppingCart,
                        null,
                        tint = if (cantCarrito > 0) RosaYendo else colorInactivo,
                        modifier = Modifier.size(28.dp)
                    )
                }
            }

            IconButton(onClick = onAbrirPerfil) {
                Icon(Icons.Default.Person, null, tint = colorInactivo, modifier = Modifier.size(28.dp))
            }
        }
    }
}
}

@Composable
fun CardPedidoActivoOverlay(pedidos: List<PedidoFirebase>, onClick: (PedidoFirebase) -> Unit) {
    if (pedidos.isEmpty()) return 

    val multiples = pedidos.size > 1
    val primerPedido = pedidos.first()
    val estadoHumano = com.yendo.mx.utils.formatEstadoHuman(primerPedido.estadoActual)

    Card(modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp).padding(top = 8.dp).height(72.dp).clickable { onClick(primerPedido) }, shape = RoundedCornerShape(20.dp), colors = CardDefaults.cardColors(containerColor = RosaYendo), elevation = CardDefaults.cardElevation(12.dp)) {
        Row(modifier = Modifier.fillMaxSize().padding(horizontal = 16.dp), verticalAlignment = Alignment.CenterVertically) {
            Box(modifier = Modifier.size(44.dp).background(Color.White.copy(alpha = 0.2f), RoundedCornerShape(12.dp)), contentAlignment = Alignment.Center) { Icon(if (multiples) Icons.Default.Layers else Icons.AutoMirrored.Filled.DirectionsBike, null, tint = Color.White) }
            Spacer(Modifier.width(12.dp))
            Column(modifier = Modifier.weight(1f)) {
                Text(if (multiples) "Tienes ${pedidos.size} pedidos activos" else "Pedido de ${primerPedido.nombreRestaurante}", color = Color.White, fontWeight = FontWeight.Bold, fontSize = 14.sp, maxLines = 1)
                Text(text = if (multiples) "Toca para gestionarlos" else "Estado: $estadoHumano", color = Color.White.copy(alpha = 0.8f), fontSize = 12.sp)
            }
            Icon(Icons.Default.ChevronRight, null, tint = Color.White)
        }
    }
}

@Composable
fun BannerAlertaOperativa(alerta: com.yendo.mx.models.AlertaZonaConfig?) {
    AnimatedVisibility(visible = alerta?.mostrar_alerta == true && alerta.mensaje.isNotEmpty(), enter = expandVertically() + fadeIn(), exit = shrinkVertically() + fadeOut()) {
        val (bgColor, icon) = when (alerta?.tipo?.uppercase()) {
            "CRITICAL", "CRITICA", "CRITICO", "DANGER", "ERROR" -> Color(0xFFD32F2F) to Icons.Default.Error
            "WARNING", "ADVERTENCIA", "ALERTA" -> Color(0xFFFF9800) to Icons.Default.Warning
            "SUCCESS", "EXITO", "OK" -> Color(0xFF4CAF50) to Icons.Default.CheckCircle
            else -> Color(0xFF2196F3) to Icons.Default.Info
        }
        Row(modifier = Modifier.fillMaxWidth().background(bgColor).padding(horizontal = 16.dp, vertical = 12.dp), verticalAlignment = Alignment.CenterVertically) {
            Icon(icon, contentDescription = "Alerta", tint = Color.White, modifier = Modifier.size(24.dp))
            Spacer(modifier = Modifier.width(12.dp))
            Text(text = alerta?.mensaje ?: "", color = Color.White, fontSize = 13.sp, fontWeight = FontWeight.Bold, modifier = Modifier.weight(1f))
        }
    }
}
